<template>
    <div>
        <div class="d-flex flex-column flex-md-row">
            <div class="w-md-500px">
                <div class="font-size-sm text-uppercase text-muted">
                    Tabs
                </div>
                <div class="btn-group bg-white rounded">
                    <button class="btn px-5"
                            :class="{'btn-primary': activeTab === 'open', 'btn-primary-secondary text-dark': activeTab !== 'open'}"
                            @click="switchTabTo('open')">
                        {{ __('orders.open') }}
                        <span class="badge ml-1 my-n1"
                              :class="{'bg-white text-dark': activeTab === 'open','bg-primary text-white': activeTab !== 'open'}">
                                    {{ openOrdersCount }}
                                </span>
                    </button>
                    <button class="btn px-5"
                            :class="{'btn-primary': activeTab === 'done', 'btn-primary-secondary text-dark': activeTab !== 'done'}"
                            @click="switchTabTo('done')">
                        {{ __('orders.all') }}
                    </button>
                </div>
            </div>
            <OrderListFilters :init-order-states="initOrderStates"
                              :init-range="initRange"
                              :init-search="initSearch"
                              :init-selected-order-types="initSelectedOrderTypes"
                              @reloadOrders="updateTableData"
                              @searchStarted="e => switchTabTo('done')"
            />
        </div>

        <div class="mt-3">
            <OrdersToProcessList v-if="activeTab === 'open'"
                                 :store="store"
                                 :pending-orders="loadedPendingOrders"
                                 :visible-order-types="initSelectedOrderTypes"
                                 :key="pendingOrderIteration"
                                 @gotoDone="switchTabTo('done')"
            />
            <OrderList v-if="activeTab === 'done'"
                       :paginator="paginatedOrders"
                       :search="initSearch"
                       :max-search-results="maxSearchResults"
                       :key="paginatedOrdersIteration"
                       @reloadOrders="updateTableData"
            />
        </div>
    </div>
</template>

<script>
import OrdersToProcessList from '@components/Orders/OrdersToProcessList';
import OrderList from '@components/Orders/OrderList';
import OrderTypeIcon from '@components/Orders/OrderTypeIcon';
import StoreImage from '@components/Store/StoreImage.vue';
import StoreAddress from '@components/Store/StoreAddress.vue';
import StoreLayout from '@layouts/StoreLayout.vue';
import Center from '@components/Layout/Center.vue';
import {PortalTarget} from 'portal-vue';
import DateRangeSelect from "@components/Form/DateRangeSelect.vue";
import OrderTypeSelect from "@components/Form/OrderTypeSelect.vue";
import {scrollToTop} from "@composables/scrollToTop";
import OrderStateSelect from "@components/Form/OrderStateSelect.vue";
import OrderListFilter from "@components/Orders/Controls/OrderListFilter.vue";
import OrderListFilters from "@components/Orders/Controls/OrderListFilters.vue";
import {rewriteUrlNew} from "@composables/rewriteUrlNew";

export default {
    layout: StoreLayout,

    components: {
        OrderListFilters,
        OrderListFilter,
        OrderStateSelect,
        OrderTypeSelect,
        DateRangeSelect,
        Center,
        StoreAddress,
        OrderList,
        OrderTypeIcon,
        OrdersToProcessList,
        StoreImage,
        PortalTarget,
    },

    props: {
        initSearch: String,
        initRange: Object,
        initOrderStates: Array,
        initSelectedOrderTypes: Object,
        pendingOrders: Array,
        paginatedOrders: Object,
        maxSearchResults: Number,
        store: Object,
        tab: {
            type: String,
            default: 'open'
        },
    },

    data() {
        return {
            loadedPendingOrders: this.pendingOrders || [],
            activeTab: this.tab,
            pendingOrderIteration: 0,
            paginatedOrdersIteration: 0,
            serverParams: {
                page: -1,
                perPage: 20,
            },
        };
    },

    mounted() {
        this.activeTab = this.tab;
        window.Echo.private('store-orders.' + this.store.id).listen('.order.created', this.handleOrderCreated).listen('.order.updated', this.handleOrderUpdated);

        if (this.paginatedOrders.current_page > this.paginatedOrders.last_page) {
            rewriteUrlNew('page', this.paginatedOrders.last_page);
            this.updateTableData();
        }
    },

    methods: {
        startSearch(searchString) {
            rewriteUrlNew('search', searchString);
            this.switchTabTo('done');
            this.updateTableData();
        },

        updateTableData(only = ['paginatedOrders', 'initSearch', 'initRange', 'initOrderStates', 'initSelectedOrderTypes', 'tab']) {
            rewriteUrlNew('page', 1);
            this.$inertia.reload({only: only});
            scrollToTop();
        },

        switchTabTo(tab) {
            this.activeTab = tab;
            rewriteUrlNew('tab', tab);
        },

        handleOrderCreated(newOrder) {
            newOrder.newClass = `unprocessed-${newOrder.type}`;
            this.loadedPendingOrders.unshift(newOrder);
            this.pendingOrderIteration++;
        },

        handleOrderUpdated(updatedOrder) {
            let foundInPending = false;
            for (let orderIndex in this.loadedPendingOrders) {
                let order = this.loadedPendingOrders[orderIndex];
                if (order.code === updatedOrder.code) {
                    this.loadedPendingOrders[orderIndex] = updatedOrder;
                    this.pendingOrderIteration++;
                    foundInPending = true;
                    break;
                }
            }

            if (!foundInPending && updatedOrder.action_required) {
                this.loadedPendingOrders.unshift(updatedOrder);
                return;
            }

            for (let orderIndex in this.paginatedOrders.data) {
                let order = this.paginatedOrders.data[orderIndex];
                if (order.code === updatedOrder.code) {
                    this.paginatedOrders.data[orderIndex] = updatedOrder;
                    this.paginatedOrdersIteration++;
                    break;
                }
            }
        },
    },

    computed: {
        openOrdersCount() {
            return this.pendingOrders.length ?? 0;
        },
    },
};
</script>
